module.exports = __webpack_public_path__ + "themes/fq/sound/audio-sprite.ogg";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sound/audio-sprite.ogg
// module id = 25
// module chunks = d-game